
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const vendorService = {
    vendorBill,getVendorBillByDate, vendorBillPayment, getVendorpaymentbyDate,
    getVendorPurchaseOrderByDate,vendorPurchaseOrder, vendorPurchaseReceive, getVendorPurchaseReceiveByDate,
    vendorLedger, getVendorLedgerByDate
    
};


async function  vendorBill(vendor_id) {
    return  apiClient.get(`/purchases/get-vendor-bill/${vendor_id}`, authHeader());
}


async function  getVendorBillByDate(formData) {
    return  apiClient.put(`/purchases/vendor-by-date`, formData, authHeader());
}


async function  vendorBillPayment(vendor_id) {
    return  apiClient.get(`/purchases/get-vendor-bill-payment/${vendor_id}`, authHeader());
}


async function  getVendorpaymentbyDate(formData) {
    return  apiClient.put(`/purchases/vendor-bill-payment-by-date`, formData, authHeader());
}

async function  vendorPurchaseOrder(vendor_id) {
    return  apiClient.get(`/purchases/get-vendor-purchase-order/${vendor_id}`, authHeader());
}


async function  getVendorPurchaseOrderByDate(formData) {
    return  apiClient.put(`/purchases/vendor-purchase-order-by-date`, formData, authHeader());
}


async function  vendorPurchaseReceive(vendor_id) {
    return  apiClient.get(`/purchases/get-vendor-purchase-receive/${vendor_id}`, authHeader());
}

async function  vendorLedger(vendor_id) {
    return  apiClient.get(`/purchases/get-vendor-ledger/${vendor_id}`, authHeader());
}


async function  getVendorLedgerByDate(formData) {
    return  apiClient.put(`/purchases/vendor-ledger-by-date`, formData, authHeader());
}

async function  getVendorPurchaseReceiveByDate(formData) {
    return  apiClient.put(`/purchases/vendor-purchase-receive-by-date`, formData, authHeader());
}

















